import { useSearchPageData } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/__internal__/useSearchPageData";

export const useSearchPageQuery = () => {
  const {
    data: productsData,
    isFetching,
    isError,
    error,
    dataUpdatedAt,
  } = useSearchPageData();

  return {
    data: productsData?.response,
    isFetching,
    isError,
    error,
    dataUpdatedAt,
  };
};
